export var BLOG_APP_DEF_ID = '14bcded7-0066-7c35-14d7-466cb3f09103';
export var RESTAURANT_MENU_APP_DEF_ID = 'b278a256-2757-4f19-9313-c05c783bec92';
